import ConnectedSliderRange from "components/screener/shared/ConnectedSliderRange";

export default function FreeFloat() {
  return (
    <div className="space-y-4">
      <div className="space-y-1">
        <h3 className="font-aeonik text-base font-bold uppercase tracking-wide text-zinc-500">Free Float</h3>
        <span className="flex font-aeonik text-sm font-normal italic tracking-wider text-slate-400">
          Selecione uma faixa de Free Float.
        </span>
      </div>

      <div className="space-y-8">
        <ConnectedSliderRange
          attribute="freeFloat.commonStock"
          label="Ações ON"
          accessibilityLabels={["Free Float mínimo das Ações Ordinárias", "Free Float máximo das Ações Ordinárias"]}
        />

        <ConnectedSliderRange
          attribute="freeFloat.preferredStock"
          label="Ações PN"
          accessibilityLabels={[
            "Free Float mínimo das Ações Preferenciais",
            "Free Float máximo das Ações Preferenciais",
          ]}
        />
      </div>
    </div>
  );
}
